
// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

// 上传图片
export async function upload(data: any) {
  return request<Apply.Result>('/api/custom/certification/common/upload', {
    method: 'POST',
    data
  });
}

// 个人认证
export async function person(options?: { [key: string]: any }) {
  return request<Apply.Result>('/api/custom/certification/certificate/person', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 企业认证
export async function enterprise(options?: { [key: string]: any }) {
  return request<Apply.Result>('/api/custom/certification/certificate/enterprise', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 认证列表
export async function certificateList(options?: { [key: string]: any }) {
  return request<Apply.Result>('/api/custom/certification/certificate/list', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 认证信息
export async function certificateInfo(options?: { [key: string]: any }) {
  return request<Apply.Result>('/api/custom/certification/certificate/user/info', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}
